<template>
    <!--这个排序表格 是用在子表里面的Sort-->
    <div id="sortTabeCom">
        <!--排序-->
        <a-modal title="Sort" v-model="SortVis" width="50%">
            <template slot="footer">
                <a-button type="primary" @click="saveSortTab">{{ $t('pubGicSet.SelectFieldName') }}</a-button>
            </template>
            <div id="test">
                <vxe-table
                        border
                        class="sortable-row-demo"
                        row-key
                        size="small"
                        ref="sortTableRefs"
                        :data.sync="editTableData"
                >
                    <template v-slot:empty>
                        <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                    </template>
                    <vxe-table-column field="fieldName" title="Field Name"></vxe-table-column>
                </vxe-table>
            </div>
        </a-modal>
    </div>
</template>
<script>
    import Sortable from "sortablejs";
    import ajax from "../../api/ajax";
    import api from "../../api/url";
    export default{
        data(){
            return{
                SortVis: false,
                editTableData: [] // 表格数据
            }
        },
        destroyed() {
            if (this.sortable) {
                this.sortable.destroy();
            }
        },
        methods:{
            show(obj){
                this.SortVis = true
                this.$message.success(this.$t('pubGicSet.DragTheListTosort'));
                ajax.get(api.SEARCHSORT, { gmcUid: obj.tableId}).then(res=>{
                    this.editTableData = res.data;
                    this.rowDrop();
                })
            },
            saveSortTab(){
                this.SortVis = false
            },
            //            推拽
            rowDrop() {
                this.$nextTick(() => {
                    let sortTable = this.$refs.sortTableRefs
                    let sortable = Sortable.create(sortTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'), {
                        onEnd: ({ newIndex, oldIndex }) => {
                            let currRow = this.editTableData.splice(oldIndex, 1)[0];
                            this.editTableData.splice(newIndex, 0, currRow);
                        }
                    });
                });
            },
        }
    }
</script>
<style>
    .sortable-row-demo .drag-btn {
        cursor: move;
        font-size: 12px;
    }
    .sortable-row-demo .vxe-body--row.sortable-ghost,
    .sortable-row-demo .vxe-body--row.sortable-chosen {
        background-color: #dfecfb;
    }
</style>